export enum ServiceProviderCapability {
  // 6.1 Service Provider – Discovery & Maps
  DISCOVERY_LISTED_IN_MAP_AND_SEARCH = "serviceProvider.discovery.listed_in_map_and_search",
  DISCOVERY_MANAGE_BASIC_PROFILE = "serviceProvider.discovery.manage_basic_profile",
  DISCOVERY_MANAGE_ASSOCIATIONS_INTERNAL = "serviceProvider.discovery.associations_harbor",

  // 6.2 Service Provider – Bookings & Payments
  BOOKINGS_MANAGE_BOOKABLE_SERVICES = "serviceProvider.bookings.manage_bookable_services",
  BOOKINGS_ACCEPT_ONLINE_BOOKINGS = "serviceProvider.bookings.accept_online_bookings",
}
